(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  const initializePrimeDesktopMenus = () => {
    const desktop = window.matchMedia('(min-width: 990px)');
    document.querySelectorAll('.ruby-menu-header ul.ruby-menu').forEach(menu => {
      if (menu.dataset.primeDropdownsReady) return;
      menu.dataset.primeDropdownsReady = 'true';
      const panels = [...menu.querySelectorAll(':scope > li > ul.sub-menu-c')];
      const flyouts = [...menu.querySelectorAll('ul.sub-menu-gc')];
      const positionFlyout = panel => {
        const owner = panel.parentElement;
        const rect = owner.getBoundingClientRect();
        const width = Math.min(panel.offsetWidth, window.innerWidth - 24);
        const height = Math.min(panel.scrollHeight + 4, window.innerHeight - 24);
        const right = rect.right - 1;
        const left = right + width <= window.innerWidth - 12
          ? right
          : Math.max(12, rect.left - width + 1);
        const top = Math.max(12, Math.min(rect.top - 4, window.innerHeight - height - 12));
        panel.style.setProperty('--prime-flyout-left', left + 'px');
        panel.style.setProperty('--prime-flyout-top', top + 'px');
      };
      const update = () => {
        if (!desktop.matches) return;
        panels.forEach(panel => {
          const top = panel.getBoundingClientRect().top;
          panel.style.setProperty('--prime-dropdown-height', Math.max(0, window.innerHeight - top - 12) + 'px');
        });
        flyouts.forEach(positionFlyout);
      };
      flyouts.forEach(panel => {
        panel.tabIndex = 0;
        panel.parentElement.addEventListener('pointerenter', update);
        panel.parentElement.addEventListener('focusin', update);
      });
      panels.forEach(panel => {
        panel.tabIndex = 0;
        panel.addEventListener('scroll', update, { passive: true });
      });
      const dropdownItems = [...menu.querySelectorAll('li')].filter(item => item.querySelector(':scope > ul.sub-menu'));
      let suppressFocus = false;
      const controlFor = item => item.querySelector(':scope > a');
      const closeDropdown = item => {
        if (!dropdownItems.includes(item)) return;
        [item, ...item.querySelectorAll('li.prime-dropdown-open')].forEach(child => {
          child.classList.remove('prime-dropdown-open');
          controlFor(child)?.setAttribute('aria-expanded', 'false');
        });
      };
      const openDropdown = item => {
        if (!desktop.matches) return;
        [...item.parentElement.children].filter(sibling => sibling !== item).forEach(closeDropdown);
        item.classList.add('prime-dropdown-open');
        controlFor(item)?.setAttribute('aria-expanded', 'true');
        update();
      };
      dropdownItems.forEach((item, index) => {
        const control = controlFor(item);
        const panel = item.querySelector(':scope > ul.sub-menu');
        if (!control) return;
        panel.id = panel.id || 'prime-desktop-dropdown-' + index;
        control.removeAttribute('href');
        control.removeAttribute('aria-current');
        control.setAttribute('role', 'button');
        control.setAttribute('tabindex', '0');
        control.setAttribute('aria-expanded', 'false');
        control.setAttribute('aria-controls', panel.id);
        item.addEventListener('pointerenter', () => openDropdown(item));
        item.addEventListener('pointerleave', () => closeDropdown(item));
        item.addEventListener('focusin', () => {
          if (!suppressFocus) openDropdown(item);
        });
        item.addEventListener('focusout', event => {
          if (!item.contains(event.relatedTarget)) closeDropdown(item);
        });
      });
      menu.addEventListener('click', event => {
        const control = event.target.closest('a[aria-controls]');
        if (!desktop.matches || !control || !menu.contains(control)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
      menu.addEventListener('keydown', event => {
        if (!desktop.matches) return;
        const control = event.target.closest('a[aria-controls]');
        if (control && (event.key === 'Enter' || event.key === ' ' || event.key === 'ArrowDown')) {
          event.preventDefault();
          openDropdown(control.parentElement);
          if (event.key === 'ArrowDown') {
            control.parentElement.querySelector(':scope > ul > li > a')?.focus();
          }
        }
        if (event.key === 'Escape') {
          const owner = dropdownItems.filter(item => item.classList.contains('prime-dropdown-open') && item.contains(event.target)).pop();
          if (!owner) return;
          event.preventDefault();
          event.stopPropagation();
          closeDropdown(owner);
          suppressFocus = true;
          controlFor(owner)?.focus();
          suppressFocus = false;
        }
      });
      menu.addEventListener('pointerenter', update);
      menu.addEventListener('focusin', update);
      window.addEventListener('resize', update, { passive: true });
      window.addEventListener('scroll', update, { passive: true });
      const header = menu.closest('.section-header');
      if (header) new ResizeObserver(update).observe(header);
      update();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePrimeDesktopMenus);
  } else {
    initializePrimeDesktopMenus();
  }

  } catch(e) { console.error(e); }
})();
})();
